import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  kitId: string;
  name: string;
};

const [useCreateSection, createSection] = createAsyncAction(
  "sections/create",
  async ({ kitId, name }: Args) => {
    const res = await API.call<{ section: string }>({
      endpoint: `/sections`,
      method: "POST",
      data: {
        kit_uuid: kitId,
        name,
      },
    });
    return { ...res, result: res.result.section };
  }
);

export default useCreateSection;
export { createSection };
